import { ConciergeProductKnowledgeParser } from "@redotech/redo-model/concierge-settings/product-knowledge";
import * as z from "zod";

export const updateProductSettings = {
  name: "updateProductSettings" as const,
  input: z.object({
    identifier: z.string(),
    hidden: z.boolean(),
    knowledge: ConciergeProductKnowledgeParser,
  }),
  output: z.null(),
};
